import { Alert } from '@shared/components';

import type { QSetGeneratorResultStatistic } from '../../types';

export interface HelperBannerProps {
  data: QSetGeneratorResultStatistic['results'];
}

const ALL_PASSED_HELPER_TEXT = 'กรุณาเลือกชุดข้อสอบที่ต้องการนำเข้า Draft เพื่อดำเนินการต่อ';

export default function HelperBanner(props: Readonly<HelperBannerProps>) {
  const { data } = props;
  const { total, totalPassed } = data;

  const totalFailed = total - totalPassed;
  const isAllPassed = total === totalPassed;

  return (
    <Alert severity={isAllPassed ? 'info' : 'warning'}>
      {isAllPassed
        ? ALL_PASSED_HELPER_TEXT
        : `พบชุดข้อสอบที่ไม่ผ่านเกณฑ์ ${totalFailed} ชุด คุณสามารถเลือกใช้ ${totalPassed} ชุดที่ผ่านเกณฑ์ หรือสร้างชุดข้อสอบใหม่ทั้งหมด`}
    </Alert>
  );
}
